import { StorageItem } from '@sib/types';

export const storageKeys = {
  showExperimentalFeatures: 'show-experimental-features',
  lastActive: 'last-active',
  userSetupStore: 'user-setup.store',
};

const showExperimentalFeatures: StorageItem = {
  get: () => localStorage.getItem(storageKeys.showExperimentalFeatures),
  set: (value: string | null) =>
    localStorage.setItem(storageKeys.showExperimentalFeatures, value || ''),
  remove: () => localStorage.removeItem(storageKeys.showExperimentalFeatures),
};

const lastActive: StorageItem<number | null> = {
  get: () => {
    const value = localStorage.getItem(storageKeys.lastActive);

    return value ? Number(value) : null;
  },
  set: (value: number | null) =>
    localStorage.setItem(storageKeys.lastActive, value?.toString() || ''),
  remove: () => localStorage.removeItem(storageKeys.lastActive),
};

export const clearLocalStorage = ({
  persistValueKeys,
}: {
  persistValueKeys: string[];
}) => {
  const persistEntries: [string, string | null][] = persistValueKeys.map(
    key => [key, localStorage.getItem(key)]
  );

  localStorage.clear();

  persistEntries.forEach(([key, value]) => {
    if (value !== null) {
      localStorage.setItem(key, value);
    }
  });
};

export default {
  showExperimentalFeatures,
  lastActive,
};
